import { Component, HostListener, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormArray, FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { DocumentsService } from 'src/app/services/document.service';
import Swal from 'sweetalert2';
import { EjerciciosComponent } from "./ejercicios/ejercicios.component";
import {ClasesComponent} from "./clases/clases.component";
import { environment } from 'src/environments/environment';
import { UtilsService } from 'src/app/services/utils.service';
import { RutinaModel, sexosRutina } from 'src/app/models/rutina.model';
import { nivelesEjercicios } from 'src/app/models/ejercicio.model';
import { ActivatedRoute, Router } from '@angular/router';
declare var $: any;

@Component({
  selector: 'app-constructor-rutinas',
  standalone: true,
    imports: [
        CommonModule,
        ReactiveFormsModule,
        FormsModule,
        EjerciciosComponent,
        ClasesComponent
    ],
  templateUrl: './constructor-rutinas.component.html',
  styleUrl: './constructor-rutinas.component.css'
})
export class ConstructorRutinasComponent implements OnInit{
  userInfo: any;
  clienteId: any;
  detalleCliente: any;
  programaId: any;
  periodoId: any;

  editarRutina: any = false;
  sets: number[] = [1, 2, 3, 4, 5, 6, 7, 8, 9]; // Opciones del select
  nivelesEjercicios = nivelesEjercicios;
  sexosRutina = sexosRutina;

  formConstructorRutina: FormGroup;
  formShowRutina: FormGroup;
  rutinaAEditar: any;
  submitFormConstructorRutina: boolean = false;
  patternRutinas = 'rutina';
  filtroNivel = '';
  filtroSexo = '';
  dataTableRutinas: any;

  rutinaSeleccionada: any; // Rutina seleccionada para mostrar detalles

  constructor(private fb: FormBuilder,
              private documentService: DocumentsService,
              private utilsService: UtilsService,
              private route: ActivatedRoute,
              private router: Router
  )
  { 
    this.formConstructorRutina = this.fb.group
    ({
      nombre: ['', [Validators.required]],
      nivel: ['Todos'],
      sexo: ['General'],
      items: this.fb.array([]),
    })

    this.formShowRutina = this.fb.group
    ({
      nombre: ['', [Validators.required]],
      nivel: ['Todos'],
      sexo: ['General'],
      items: this.fb.array([]),
    })
  }

  ngOnInit(): void {
    $('#sidebar-overlay').click();

    this.userInfo = JSON.parse(localStorage.getItem('userData'));
    this.getRutinas();
    
    this.route.paramMap.subscribe(params => {
      this.clienteId = params.get('clienteId');
      this.programaId = params.get('programaId');
      this.periodoId = params.get('periodoId');
      // console.log(this.clienteId, this.programaId, this.periodoId);
      if(this.clienteId) {
        this.getDetalleCliente();
        this.filtroPeriodoActivo = this.periodoId-1;
      } else if(this.programaId) {
        this.getProgramas();
        this.getDetallePrograma(this.programaId, true);
        this.filtroPeriodoActivo = this.periodoId-1;
      }
    });
  }

  isCollapsedEjercicios = false;
  toggleCollapseEjercicios() {
    this.isCollapsedEjercicios = !this.isCollapsedEjercicios;
  }
  isCollapsedConstructor = false;
  toggleCollapseConstructor() {
    this.isCollapsedConstructor = !this.isCollapsedConstructor;
  }
  isLargeScreen: boolean = window.innerWidth > 991;
  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.isLargeScreen = event.target.innerWidth > 991;
  }
  navigateBack() {
    sessionStorage.setItem('seccion', 'calendario');
    sessionStorage.setItem('subseccion', 'rutinas');
    sessionStorage.setItem('seccionPeriodoId', this.periodoId);
    if(this.clienteId) { //'expediente cliente'
      sessionStorage.setItem('seccionProgramaId', this.programaId);
      this.router.navigate(['trainer/config-programa', this.detalleCliente.documentId])
    } else { //'programa prediseñado'
      this.router.navigate(['trainer/config-programa', this.programaId])
    }
  }


  listaRutinas: any;
  getRutinas(){
    const filters: any = {
      "documentContainerId": this.userInfo.documentContainerId,
      "empresaId": this.userInfo.empresaId,
      "activo": true
    };
    // GET FILTERS ARRAY
    let filtersQuery: any = this.documentService.getFiltersArray(filters);

    
    if(this.filtroNivel != '') {
      filtersQuery.push({
        "match_phrase": {
          "nivel.keyword": this.filtroNivel
        }
      });
    }
    if(this.filtroSexo != '') {
      filtersQuery.push({
        "match_phrase": {
          "sexo.keyword": this.filtroSexo
        }
      });
    }
    const query = {
      "sort": [
        {
          "esDocumentDate": {
            "order": "desc",
            "unmapped_type": "boolean"
          }
        }
      ],
      "size": 200,
      "query": {
        "bool": {
          "must": [],
          "filter": filtersQuery,
          "should": [],
          "must_not": []
        }
      }
    };
    setTimeout(() => {
      this.documentService.searchDocument(environment.businessId, this.patternRutinas, query).subscribe({
        next: (data: any) => {
          console.log('listaRutinas', data)
          if(this.dataTableRutinas) {
            this.dataTableRutinas.destroy();
            this.dataTableRutinas = null; // Eliminar la referencia
          }
          this.listaRutinas = [];
          this.listaRutinas = data;
          this.inicializarDataTableRutinas();
        },
          error: (error: any) => {
          console.error(error);
          this.listaRutinas = [];
          this.inicializarDataTableRutinas();
        }
      });
    }, 1500);
  }
  inicializarDataTableRutinas()
  {
    if (this.dataTableRutinas) {
      this.dataTableRutinas.destroy(); // Destruir la instancia existente de la DataTable
    }
    $(document).ready(() => {
      this.dataTableRutinas = $('#dataTable-listaRutinas').DataTable({
        language: {
          search: "Buscar:",
          lengthMenu: "Mostrar _MENU_ registros",
          info: "Mostrando _START_ al _END_ de _TOTAL_ registros",
          infoEmpty: "Mostrando 0 al 0 de 0 registros",
          infoFiltered: "(filtrados de _MAX_ registros en total)",
          paginate: {
            first: "Primero",
            last: "Último",
            next: "Siguiente",
            previous: "Anterior",
          },
          emptyTable: "No hay datos disponibles en esta tabla"
        },
        pageLength: 10,
      });
    });
  }
  listaProgramas: any;
  getProgramas() {
    this.documentService.getDocumentsByType(
      environment.businessId,
      this.userInfo.documentContainerId,
      "programa"
    ).subscribe({
      next: (data: any) => {
        this.listaProgramas = data.content;
        // Dejar solo los programas de tipo '2'
        this.listaProgramas = this.listaProgramas.filter(p => p.tipo == 2);
        console.log('listaProgramas', this.listaProgramas)

        this.listaInactivos = [];
        for(let programa of this.listaProgramas) {
          if(programa.documentId != this.programaId) {
            this.listaInactivos.push(programa);
          }
        }
        this.inicializarDataTableRutinasInactivas();
        console.log('listaInactivos', this.listaInactivos)
      },
      error: (error) => {
        console.log(error);
      }
    })
  }
  periodosProgramaActivo: any = [];
  getDetallePrograma(documentId, setPeriodos: boolean)
  {
    this.documentService.getDocumentById(environment.businessId, this.userInfo.documentContainerId, documentId).subscribe((res: any) => {
      console.log('detallePrograma', res)
      this.detallePrograma = res;
      if(setPeriodos) this.periodosProgramaActivo = this.detallePrograma.periodos ? [...this.detallePrograma.periodos] : [];
      console.log('periodosProgramaActivo', this.periodosProgramaActivo)
      this.onChangeRutinasPeriodoSelected(this.filtroPeriodoActivo);
      // this.inicializarDataTableRutinasActivas(null);
    }, err => {
      console.error(err)
    })
  }
  onChangeRutinasPeriodoSelected(id) {
    this.filtroPeriodoActivo = id;
    this.rutinasPeriodoActivo = this.detallePrograma.periodos[this.filtroPeriodoActivo].rutinas ? [...this.detallePrograma.periodos[this.filtroPeriodoActivo].rutinas] : [];
    this.inicializarDataTableRutinasActivas(null);
  }

  listaInactivos: any;
  detalleActivo: any = {};
  rutinasPeriodoActivo: any = [];
  detallePrograma: any;
  filtroPeriodoInactivo: any = 0;
  filtroPeriodoActivo: any = 0;
  filtroProgramaInactivo: any = 0;
  getDetalleCliente()
  {
    this.documentService.getDocumentById(environment.businessId, this.userInfo.documentContainerId, this.clienteId).subscribe((res: any) => {
      this.listaInactivos = [];
      this.detalleActivo = {};

      console.log('detalleCliente', res)
      this.detalleCliente = res;

      const programasCliente = this.detalleCliente.expediente?.programas;
      const index = programasCliente.findIndex((p) => p.configuracionPrograma.id == this.programaId);
      if(index != -1) {
        this.detallePrograma = programasCliente[index];

        this.detalleActivo = programasCliente[index].periodos[this.filtroPeriodoActivo];
        // this.detalleActivo = programasCliente[index].periodos[this.periodoId-1];

        this.periodosProgramaActivo = programasCliente[index].periodos ? [...programasCliente[index].periodos] : [];

        this.rutinasPeriodoActivo = programasCliente[index].periodos[this.filtroPeriodoActivo].rutinas ? programasCliente[index].periodos[this.filtroPeriodoActivo].rutinas : [];
        // this.rutinasPeriodoActivo = programasCliente[index].periodos[this.periodoId-1].rutinas ? programasCliente[index].periodos[this.periodoId-1].rutinas : [];
      }
      for(let programa of programasCliente) {
        if(programa.configuracionPrograma.id != this.programaId) {
          this.listaInactivos.push(programa);
        }
      }
      console.log('listaInactivos', this.listaInactivos)
      console.log('detalleActivo', this.detalleActivo)
      this.inicializarDataTableRutinasActivas(null);
      this.inicializarDataTableRutinasInactivas();
    }, err => {
      console.error(err)
    })
  }
  dataTableRutinasActivas: any;
  inicializarDataTableRutinasActivas(rutina: any)
  {
    this.filtroPeriodoActivo = this.filtroPeriodoActivo
    console.log('rutinasPeriodoActivo', this.rutinasPeriodoActivo)
    if (this.dataTableRutinasActivas) {
      this.dataTableRutinasActivas.destroy(); // Destruir la instancia existente de la DataTable
    }
    if(rutina) {
      this.detalleActivo.rutinas.push(rutina);
      // ordenar por nombre
      this.detalleActivo.rutinas.sort((a, b) => a.nombre.localeCompare(b.nombre));
    }
    $(document).ready(() => {
      this.dataTableRutinasActivas = $('#dataTable-listaRutinasActivas').DataTable({
        language: {
          search: "Buscar:",
          lengthMenu: "Mostrar _MENU_ registros",
          info: "Mostrando _START_ al _END_ de _TOTAL_ registros",
          infoEmpty: "Mostrando 0 al 0 de 0 registros",
          infoFiltered: "(filtrados de _MAX_ registros en total)",
          paginate: {
            first: "Primero",
            last: "Último",
            next: "Siguiente",
            previous: "Anterior",
          },
          emptyTable: "No hay datos disponibles en esta tabla"
        },
        pageLength: 10,
      });
    });
  }
  dataTableRutinasInactivas: any;
  inicializarDataTableRutinasInactivas()
  {
    if (this.dataTableRutinasInactivas) {
      this.dataTableRutinasInactivas.destroy(); // Destruir la instancia existente de la DataTable
    }
    $(document).ready(() => {
      this.dataTableRutinasInactivas = $('#dataTable-listaRutinasInactivas').DataTable({
        language: {
          search: "Buscar:",
          lengthMenu: "Mostrar _MENU_ registros",
          info: "Mostrando _START_ al _END_ de _TOTAL_ registros",
          infoEmpty: "Mostrando 0 al 0 de 0 registros",
          infoFiltered: "(filtrados de _MAX_ registros en total)",
          paginate: {
            first: "Primero",
            last: "Último",
            next: "Siguiente",
            previous: "Anterior",
          },
          emptyTable: "No hay datos disponibles en esta tabla"
        },
        pageLength: 10,
      });
    });
  }

  /**************************************************/
  /********** AGREGAR ELEMENTOS A RUTINA ************/
  /**************************************************/
  setFormConstructorRutina(
    tipo: 'titulo' | 'comentario' | 'ejercicio' | 'clase', 
    ejercicioOrClase, 
    elemento //se manda el elemento si se está editan una rutina
  ) {
    const arreglo = this.formConstructorRutina.get('items') as FormArray;
    let nombre = null;
    if(tipo == 'ejercicio' || tipo == 'clase')
    {
      if(tipo == 'ejercicio') nombre = ejercicioOrClase.nombre1
      if(tipo == 'clase') nombre = ejercicioOrClase.nombre
      const index = arreglo.controls.findIndex(control => 
        control.value.documentId === ejercicioOrClase.documentId &&
        control.value.nombre === nombre
      );
      /*
      if (index !== -1) {
        let text = '';
        if(tipo == 'ejercicio') text = 'El ejercicio'
        if(tipo == 'clase') text = 'La clase'
        Swal.fire({
          toast: true, // Activa el estilo tipo Toast
          position: 'bottom-end', // Posición del mensaje
          icon: 'warning',
          title: text+' ya existe en la rutina.',
          showConfirmButton: false,
          timer: 3000, // Tiempo de duración del mensaje (3 segundos)
          timerProgressBar: true // Muestra una barra de progreso
        });
        return;
      }*/
    }

    const grupo = this.fb.group({
      circuitoId:     elemento?.circuitoId ? elemento?.circuitoId : null,
      setsCircuito:   elemento?.setsCircuito ? elemento.setsCircuito : 1,
      startCircuito:  elemento?.startCircuito ? elemento.startCircuito : false,
      tipo:           tipo,
      documentId:     ejercicioOrClase ? ejercicioOrClase.documentId : null,
      nombre:         nombre,
      texto:          elemento?.texto ? elemento.texto : '',
      isSelected:     [false, [Validators.required]],
      objInfo:        ejercicioOrClase ? ejercicioOrClase : null, // se guarda todo el objeto
    })

    arreglo.push(grupo);
    // console.log(this.formConstructorRutina.value)
  }
  removeElemento(index: any) {
    const arreglo = this.formConstructorRutina.get('items') as FormArray;
    arreglo.removeAt(index);
  }

  // Verifica si los elementos seleccionados son consecutivos
  validarElementosSeleccionadosConsecutivos(): boolean {
    const items = this.formConstructorRutina.get('items') as FormArray;

      // Obtener los índices de los elementos seleccionados cuyo tipo sea 'clase' o 'ejercicio'
      const selectedIndices = items.controls
      .map((control, index) => {
        const isSelected = control.get('isSelected').value;
        const tipo = control.get('tipo').value; // Obtener el tipo del control
        return isSelected && (tipo === 'clase' || tipo === 'ejercicio') ? index : -1;
      })
      .filter(index => index !== -1);

    // Si hay menos de 2 seleccionados, retorna false
    if (selectedIndices.length < 2) {
      Swal.fire({
        icon: 'warning',
        title: 'Error',
        text: 'Debes seleccionar al menos dos ejercicios consecutivos.',
        timer: 5000,
        toast: true,
        position: 'bottom-end',
        showConfirmButton: false,
      });
      return false;
    }

    // Verificar si los índices son consecutivos
    for (let i = 1; i < selectedIndices.length; i++) {
      if (selectedIndices[i] !== selectedIndices[i - 1] + 1) {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Los ejercicios seleccionados no son consecutivos.',
          timer: 5000,
          toast: true,
          position: 'bottom-end',
          showConfirmButton: false,
        });
        return false;
      }
    }
    return true;
  }

  // Función para manejar la acción de crear un circuito
  crearCircuito(): void {
    if (this.validarElementosSeleccionadosConsecutivos()) {
      const items = this.formConstructorRutina.get('items') as FormArray;

      // Generar un UUID para el circuito
      const circuitoId = this.utilsService.create_UUID();

      // Asignar el circuitoId a los elementos seleccionados
      let i = 0;
      items.controls.forEach((control) => {
        if (control.get('isSelected').value) {
          control.patchValue({ circuitoId: circuitoId, isSelected: false });
          if(i==0) {
            control.patchValue({ startCircuito: true });
            i+=1;
          }
        }
      });

      Swal.fire({
        icon: 'success',
        title: 'Circuito creado',
        text: 'Los ejercicios seleccionados se añadieron al circuito.',
        timer: 5000,
        toast: true,
        position: 'bottom-end',
        showConfirmButton: false,
      });
      // Aquí puedes realizar la lógica para agregar el circuito
      console.log('Elementos válidos. Crear circuito...');
      console.log(this.formConstructorRutina.value)
    }
  }
  // Función para deshacer un circuito
  deshacerCircuito(circuitoId: string): void {
    const items = this.formConstructorRutina.get('items') as FormArray;

    // Verificar si existe algún elemento con el circuitoId especificado
    const circuitoEncontrado = items.controls.some(control => control.get('circuitoId').value === circuitoId);
    if (!circuitoEncontrado) {
      Swal.fire({
        icon: 'warning',
        title: 'Error',
        text: 'No se encontró un circuito con el ID especificado.',
        timer: 5000,
        toast: true,
        position: 'bottom-end',
        showConfirmButton: false,
      });
      return;
    }

    // Restablecer los valores de circuitoId y startCircuito para los elementos correspondientes
    items.controls.forEach(control => {
      if (control.get('circuitoId').value === circuitoId) {
        control.patchValue({
          circuitoId: null,
          startCircuito: false,
        });
      }
    });

    Swal.fire({
      icon: 'success',
      title: 'Circuito deshecho',
      timer: 5000,
      toast: true,
      position: 'bottom-end',
      showConfirmButton: false,
    });
  }

  validarFormConstructorRutina(guardarEn: 'biblioteca'|'periodo')
  {
    this.submitFormConstructorRutina = true;
    if(this.formConstructorRutina.invalid)
    {
      Swal.fire('Advertencia', 'Verifica que los campos sean válidos.', 'warning');
      return;
    }

    // Verificar si no hay elementos en el array `items`
    const items = this.formConstructorRutina.get('items').value;
    if (items.length <= 0) {
      Swal.fire('Advertencia', 'Agrega al menos dos elementos de tipo clase o ejercicio.', 'warning');
      return;
    }

    // Verificar si hay al menos 2 elementos de tipo `clase` o `ejercicio`
    const elementosValidos = items.filter(
      (item: any) => item.tipo === 'clase' || item.tipo === 'ejercicio'
    );
    if (elementosValidos.length < 2) {
      Swal.fire('Advertencia', 'Agrega al menos dos elementos de tipo clase o ejercicio para continuar.', 'warning');
      return;
    }
    this.createOrUpdateRutina(guardarEn);
  }
  createOrUpdateRutina(guardarEn: 'biblioteca'|'periodo')
  {
    // console.log(this.formConstructorRutina.value)
    let detalleRutina = [];
    for(let item of this.formConstructorRutina.get('items').value)
    {
      let elemento: any = {
        tipo: item.tipo,
        startCircuito: item.startCircuito,
        texto: item.texto
      }
      if(item.startCircuito) elemento.setsCircuito = Number(item.setsCircuito)
      if(item.circuitoId) elemento.circuitoId = item.circuitoId
      if(item.tipo == 'ejercicio' || item.tipo == 'clase') elemento.objInfo = item.objInfo

      detalleRutina.push(elemento)
    }

    // Numero de ejercicios
    const numeroEjercicios = this.formConstructorRutina.get('items').value.filter((item: any) => item.tipo === 'clase' || item.tipo === 'ejercicio');
    
    // Document container rutina
    let rutinaDocModel: RutinaModel = {
      activo:           true,
      nombre:           this.formConstructorRutina.get('nombre').value,
      nivel:            this.formConstructorRutina.get('nivel').value,
      totalEjercicios:  numeroEjercicios.length,
      sexo:             this.formConstructorRutina.get('sexo').value,
      detalle:          detalleRutina,
      propietario:      this.userInfo.documentContainerId,
      empresaId:        this.userInfo.empresaId
    }
    console.log(rutinaDocModel)

    if(guardarEn === 'periodo') {
      if(this.clienteId) {
        this.updateRutinaCliente(rutinaDocModel);
      } else {
        this.updateRutinaPrograma(rutinaDocModel)
      }
    }
    if(guardarEn === 'biblioteca') {
      if(this.editarRutina) this.updateRutinaFn(rutinaDocModel, this.editarRutina.documentId);
      if(!this.editarRutina) this.createRutinaFn(rutinaDocModel);
    }
  }
  /********* CREAR RUTINA *******/
  createRutinaFn(rutinaDocModel) {
    
    const rutinaEncontrada = this.listaRutinas.find(rutina => rutina.nombre === rutinaDocModel.nombre);

    if (rutinaEncontrada) {
      rutinaDocModel.documentId = rutinaEncontrada.documentId; 
      Swal.fire({
        title: 'Advertencia',
        html: 'Ya existe una rutina con el nombre: <b>"'+rutinaDocModel.nombre+'"</b>.<br>¿Desea actualizarla?',
        icon: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Confirmar'
      }).then((result) => {
        if (result.isConfirmed) { // Solo se ejecuta si el usuario confirma
          this.updateRutinaFnSinAdvertencia(rutinaDocModel, rutinaEncontrada.documentId);
        } else {
          return; // No hace nada si el usuario cancela
        }
      });
    } else {
      // Si no existe la rutina, la crea directamente sin mostrar la advertencia
      this.documentService.createDocumentInContainer(
        environment.businessId,
        this.userInfo.documentContainerId,
        null,
        this.patternRutinas,
        null,
        rutinaDocModel,
      ).subscribe({
        next: (data) => {
          console.log(data);
          this.submitFormConstructorRutina = false;
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Rutina guardada con éxito",
            showConfirmButton: false,
            timer: 1500
          });
          this.getRutinas();
        },
        error: (error) => {
          console.error(error);
        },
      });
    }
  }
  updateRutinaFnSinAdvertencia(rutinaDocModel, documentId) {
    // console.log('updateRutinaFnSinAdvertencia', rutinaDocModel)
    // console.log('documentId', documentId);
    // const rutinaEncontrada = this.listaRutinas.find(rutina => rutina.nombre === rutinaDocModel.nombre);
    // rutinaDocModel.documentId = rutinaEncontrada.documentId; 
    let title = ''
    title = "Rutina actualizada con éxito";

    this.documentService.updateDocumentInContainer(
      environment.businessId,
      this.userInfo.documentContainerId,  //DocContId del usuario loggeado (email)
      documentId,
      this.patternRutinas,
      null,
      rutinaDocModel
    ).subscribe({
      next: (data) => {
        console.log(data);
        this.submitFormConstructorRutina = false;
        Swal.fire({
          position: "top-end",
          icon: "success",
          title: title,
          showConfirmButton: false,
          timer: 1500
        });
        this.getRutinas();
        //this.inicializarFormConstructorRutina();
      },
      error: (error) => {
        console.error(error);
      },
    });
  }

  /********* ACTUALIZAR RUTINA *******/
  updateRutinaFn(rutinaDocModel, documentId) {
    console.log('updateRutinaFn', rutinaDocModel)
    console.log('documentId', documentId);
    const rutinaEncontrada = this.listaRutinas.find(rutina => rutina.nombre === rutinaDocModel.nombre);
    if (!rutinaEncontrada) {
      console.log("El nombre no existe en la lista de rutinas.");
      this.createRutinaFn(rutinaDocModel);
    } else {
      Swal.fire({
        title: 'Advertencia',
        html: 'Ya existe una rutina con el nombre: <b>"'+rutinaDocModel.nombre+'"</b>.<br>¿Desea actualizarla con estos valores?',
        icon: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Confirmar'
      }).then((result) => {
        if (result.isConfirmed) { // Solo se ejecuta si el usuario confirma
          // rutinaDocModel.documentId = rutinaEncontrada.documentId; 
          let title = ''
          if(rutinaDocModel.activo) title = "Rutina actualizada con éxito";
          if(!rutinaDocModel.activo) title = "Rutina eliminada con éxito";

          this.documentService.updateDocumentInContainer(
            environment.businessId,
            this.userInfo.documentContainerId,  //DocContId del usuario loggeado (email)
            documentId,
            this.patternRutinas,
            null,
            rutinaDocModel
          ).subscribe({
            next: (data) => {
              console.log(data);
              this.submitFormConstructorRutina = false;
              Swal.fire({
                position: "top-end",
                icon: "success",
                title: title,
                showConfirmButton: false,
                timer: 1500
              });
              this.getRutinas();
              //this.inicializarFormConstructorRutina();
            },
            error: (error) => {
              console.error(error);
            },
          });
        } else {
          return; // No hace nada si el usuario cancela
        }
      });
    }
  }

  // Editar rutinas de un cliente
  updateRutinaCliente(rutinaDocModel)
  {
    console.log('========================== updateRutinaCliente =================================')
    // console.log('rutinaDocModel', rutinaDocModel)
    // console.log('detalleCliente', this.detalleCliente)
    let programas = [...this.detalleCliente.expediente.programas];
    const indexPrograma = programas.findIndex((item) => item.configuracionPrograma.id == this.detallePrograma?.configuracionPrograma.id);

    let periodo = {...programas[indexPrograma].periodos[this.filtroPeriodoActivo]};
    //let periodo = {...programas[indexPrograma].periodos[this.periodoId-1]};
    console.log('periodo', periodo)
    
    const rutinaEncontrada = periodo.rutinas?.findIndex(rutina => rutina.nombre === rutinaDocModel.nombre);
    if(rutinaEncontrada != undefined && rutinaEncontrada != -1) {
      rutinaDocModel.documentId = periodo.rutinas[rutinaEncontrada].documentId;
      console.log('rutinaDocModel', rutinaDocModel)
      Swal.fire({
        title: 'Advertencia',
        html: 'Ya existe una rutina con el nombre: <b>"'+rutinaDocModel.nombre+'"</b>.<br>¿Desea actualizarla con estos valores?',
        icon: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Confirmar'
      }).then((result) => {
        // Actualiza la info de la rutina
        if (result.isConfirmed) { // Solo se ejecuta si el usuario confirma
          this.updateRutinaFnSinAdvertencia(rutinaDocModel, periodo.rutinas[rutinaEncontrada].documentId);
        } else {
          return; // No hace nada si el usuario cancela
        }
      });
    } else {
      // debugger;
      // Crea una nueva rutina
      let rutinaClienteDocModel: any = rutinaDocModel;
      rutinaClienteDocModel.programaId = this.programaId;
      rutinaClienteDocModel.periodoId = this.filtroPeriodoActivo;

      //rutinaClienteDocModel.periodoId = this.periodoId;
      rutinaClienteDocModel.clienteId = this.detalleCliente.documentId;

      this.documentService.createDocumentInContainer(
        environment.businessId,
        this.userInfo.documentContainerId,
        null,
        this.patternRutinas,
        null,
        rutinaClienteDocModel,
      ).subscribe({
        next: (data) => {
          // debugger;
          console.log(data);
          this.submitFormConstructorRutina = false;
          let rutina: any = {nombre: rutinaDocModel.nombre, documentId: data.documentId};
          this.filtroPeriodoActivo
          if(!programas[indexPrograma].periodos[this.filtroPeriodoActivo].rutinas) programas[indexPrograma].periodos[this.filtroPeriodoActivo].rutinas = [];
          programas[indexPrograma].periodos[this.filtroPeriodoActivo].rutinas.push(rutina);

          // if(!programas[indexPrograma].periodos[this.periodoId-1].rutinas) programas[indexPrograma].periodos[this.periodoId-1].rutinas = [];
          // programas[indexPrograma].periodos[this.periodoId-1].rutinas.push(rutina);
          console.log('programas', programas)
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Rutina guardada con éxito",
            showConfirmButton: false,
            timer: 1500
          });
          this.getRutinas();
          this.updateClienteDocument(programas, rutina);
        },
        error: (error) => {
          console.error(error);
        },
      });
    }
  }
  updateClienteDocument(programas, rutina)
  {
    // debugger;
    // console.log('updateClienteDocument', rutinaDocModel)
    console.log('programas', programas)
    let expedienteClienteDocument: any = {
      expediente: { 
        programas: programas
      }
    }
    console.log('--> expedienteClienteDocument', expedienteClienteDocument)
    this.documentService.updateDocumentInContainer(
      environment.businessId,
      this.userInfo.documentContainerId,
      this.detalleCliente.documentId,
      "cliente",
      null,
      expedienteClienteDocument
    ).subscribe({
      next: (data: any) => {
        console.log(data);
      },
      error: (error) => {
        console.log(error);
      },
      complete: () => {
        // debugger;
        // this.getDetalleCliente();  
        console.log(this.detalleCliente)
        // this.detalleActivo.rutinas.push({...rutina});
        // this.getDetalleCliente();
        this.inicializarDataTableRutinasActivas(rutina);
        // this.inicializarDataTableRutinasActivasInactivas('#dataTable-listaRutinasActivas');
        console.log(this.detalleCliente)

        Swal.fire({
          toast: true, // Activa el estilo tipo Toast
          position: 'bottom-end', // Posición del mensaje
          icon: 'success',
          title: 'Periodo actualizado con éxito.',
          showConfirmButton: false,
          timer: 3000, // Tiempo de duración del mensaje (3 segundos)
          timerProgressBar: true // Muestra una barra de progreso
        });
      }
    })
  }

  // Editar rutinas en programa prediseñado
  updateRutinaPrograma(rutinaDocModel)
  {
    console.log('updateRutinaPrograma', rutinaDocModel)
    console.log('detallePrograma', this.detallePrograma)
    let periodos = [...this.detallePrograma.periodos];

    let periodo = periodos[this.filtroPeriodoActivo];
    // let periodo = periodos[this.periodoId-1];
    
    const rutinaEncontrada = periodo.rutinas?.findIndex(rutina => rutina.nombre === rutinaDocModel.nombre);
    if(rutinaEncontrada != undefined && rutinaEncontrada != -1) {
      rutinaDocModel.documentId = periodo.rutinas[rutinaEncontrada].documentId;
      console.log('rutinaDocModel', rutinaDocModel)
      Swal.fire({
        title: 'Advertencia',
        html: 'Ya existe una rutina con el nombre: <b>"'+rutinaDocModel.nombre+'"</b>.<br>¿Desea actualizarla con estos valores?',
        icon: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Confirmar'
      }).then((result) => {
        if (result.isConfirmed) { // Solo se ejecuta si el usuario confirma
          this.updateRutinaFnSinAdvertencia(rutinaDocModel, periodo.rutinas[rutinaEncontrada].documentId);
        } else {
          return; // No hace nada si el usuario cancela
        }
      });
    } else {
      let rutinaClienteDocModel: any = rutinaDocModel;
      rutinaClienteDocModel.programaId = this.programaId;

      rutinaClienteDocModel.periodoId = this.filtroPeriodoActivo;
      // rutinaClienteDocModel.periodoId = this.periodoId;

      this.documentService.createDocumentInContainer(
        environment.businessId,
        this.userInfo.documentContainerId,
        null,
        this.patternRutinas,
        null,
        rutinaClienteDocModel,
      ).subscribe({
        next: (data) => {
          console.log(data);
          this.submitFormConstructorRutina = false;
          let rutina: any = {nombre: rutinaDocModel.nombre, documentId: data.documentId};

          if(!periodos[this.filtroPeriodoActivo].rutinas) periodos[this.filtroPeriodoActivo].rutinas = [];
          periodos[this.filtroPeriodoActivo].rutinas.push(rutina);

          // if(!periodos[this.periodoId-1].rutinas) periodos[this.periodoId-1].rutinas = [];
          // periodos[this.periodoId-1].rutinas.push(rutina);
          console.log('periodos', periodos)
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Rutina guardada con éxito",
            showConfirmButton: false,
            timer: 1500
          });
          this.getRutinas();
          this.updateProgramaDocument(periodos);
        },
        error: (error) => {
          console.error(error);
        },
      });
    }
  }
  updateProgramaDocument(periodos)
  {
    // debugger
    // let dietas: any = []
    // dietas= [
    //   {
    //     "documentId": "C8BFDAF2-A811-4742-841E-071CEC3F827E",
    //     "nombre": "Dieta Lunes Miercoles Viernes"
    //   },
    //   {
    //     "documentId": "66E9ADEE-9599-41E1-A94B-A6B5F9AC7522",
    //     "nombre": "Dieta Martes Jueves Sabado"
    //   }
    // ]
    // periodos[0].dietas = dietas
    let programaDocument: any = {};
    programaDocument = {
      periodos: periodos
    }
    // console.log('--> programaDocument',programaDocument)
    this.documentService.updateDocumentInContainer(
      environment.businessId,
      this.userInfo.documentContainerId,
      this.detallePrograma.documentId,
      "programa",
      null,
      programaDocument
    ).subscribe({
      next: (data: any) => {
        console.log(data);
        this.getDetallePrograma(this.programaId, false);
        Swal.fire({
          toast: true, // Activa el estilo tipo Toast
          position: 'bottom-end', // Posición del mensaje
          icon: 'success',
          title: 'Periodo actualizado con éxito.',
          showConfirmButton: false,
          timer: 3000, // Tiempo de duración del mensaje (3 segundos)
          timerProgressBar: true // Muestra una barra de progreso
        });
      },
      error: (error) => {
        console.log(error);
      }
    })
  }
  

  // Setear valores para EDITAR RUTINA
  goEditarRutina(rutina, documentId)
  {
    $('#modal-detalle-rutina').modal('hide');
    this.cerrarModalDetalleRutina();
    this.formConstructorRutina.reset();
    if(this.formConstructorRutina.get('items').value.length > 0)
    {
      Swal.fire('Advertencia', "No se puede agregar una rutina a una rutina que ya tiene ejercicios.<br> Elimine los elementos de la comida si quiere agregar la rutina.", 'warning');
      return;
    }
    if(documentId) {
      const index = this.listaRutinas.findIndex(rutina => rutina.documentId === documentId);
      if(typeof this.listaRutinas[index] == 'undefined'){
        this.editarRutina = rutina;
      }else{
        this.editarRutina = this.listaRutinas[index];
      }
    } else this.editarRutina = rutina;
    // console.log('editarRutina', this.editarRutina)
    
    this.formConstructorRutina.patchValue({
      nombre: this.editarRutina.nombre,
      nivel: this.editarRutina.nivel,
      sexo: this.editarRutina.sexo,
    })
    for(let elemento of this.editarRutina.detalle) this.setFormConstructorRutina(elemento.tipo, elemento.objInfo, elemento);
    console.log(this.formConstructorRutina.value)
  }
  /********* ELIMINAR RUTINA *******/
  deleteRutinaFn(rutinaDocModel) {
    Swal.fire({
      title: 'Eliminar rutina',
      html: '¿Seguro que desea eliminar la rutina: <b>"'+rutinaDocModel.nombre+'"</b>?',
      icon: 'warning',
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Confirmar'
    }).then((result) => {
      if (result.isConfirmed) {
        $('#modal-detalle-rutina').modal('hide');
        this.cerrarModalDetalleRutina();
        this.formConstructorRutina.reset();
        rutinaDocModel.activo = false;
        //this.updateRutinaFn(rutinaDocModel, rutinaDocModel.documentId);
        this.documentService.updateDocumentInContainer(
            environment.businessId,
            this.userInfo.documentContainerId,  //DocContId del usuario loggeado (email)
            rutinaDocModel.documentId,
            this.patternRutinas,
            null,
            rutinaDocModel
        ).subscribe({
          next: (data) => {
            console.log(data);
            this.submitFormConstructorRutina = false;
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: 'Rutina eliminada con éxito',
              showConfirmButton: false,
              timer: 1500
            });
            this.getRutinas();
            //this.inicializarFormConstructorRutina();
          },
          error: (error) => {
            console.error(error);
          },
        });
      }
    })
  }
  deleteRutinaEnClienteFn(rutinaDocModel, index) {
    // console.log('deleteRutinaEnClienteFn', rutinaDocModel)
    // console.log('index', index)
    Swal.fire({
      title: 'Eliminar rutina',
      html: '¿Seguro que desea eliminar la rutina: <b>"'+rutinaDocModel.nombre+'"</b>?',
      icon: 'warning',
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Confirmar'
    }).then((result) => {
      if (result.isConfirmed) {
        let programas = [...this.detalleCliente.expediente.programas];
        const indexPrograma = programas.findIndex((item) => item.configuracionPrograma.id == this.detallePrograma?.configuracionPrograma.id);
        programas[indexPrograma].periodos[this.filtroPeriodoActivo].rutinas.splice(index, 1);

        // Eliminar rutina de rutinasPorDia si existe
        for(let dia of programas[indexPrograma].periodos[this.filtroPeriodoActivo].rutinasPorDia) {
          if(dia.rutina?.documentId == rutinaDocModel.documentId) {
            dia.rutina = {};
          }
        }
        
        let expedienteClienteDocument: any = {
          expediente: { 
            programas: programas
          }
        }
        // console.log('--> expedienteClienteDocument', expedienteClienteDocument)
        
        // Eliminar rutina en el expediente del cliente
        this.documentService.updateDocumentInContainer(
          environment.businessId,
          this.userInfo.documentContainerId,
          this.detalleCliente.documentId,
          "cliente",
          null,
          expedienteClienteDocument
        ).subscribe({
          next: (data: any) => {
            this.detalleActivo = {};
            this.rutinasPeriodoActivo = [];
            // this.rutinasPeriodoActivo.splice(index, 1);

            // inicializa informacion de cliente y rutinas activas
            this.detalleCliente = data;
            const programasCliente = this.detalleCliente.expediente?.programas;
            const index = programasCliente.findIndex((p) => p.configuracionPrograma.id == this.programaId);
            if(index != -1) {
              this.detallePrograma = programasCliente[index];
              this.detalleActivo = programasCliente[index].periodos[this.filtroPeriodoActivo];
              this.rutinasPeriodoActivo = programasCliente[index].periodos[this.filtroPeriodoActivo].rutinas ? programasCliente[index].periodos[this.filtroPeriodoActivo].rutinas : [];
            }
            // this.detalleActivo.rutinas.push(rutina);
            console.log('rutinasPeriodoActivo', this.rutinasPeriodoActivo)
            this.inicializarDataTableRutinasActivas(null);
            console.info('Periodo actualizado con éxito.');

            // Eliminar rutina en la biblioteca
            rutinaDocModel.activo = false;
            this.documentService.updateDocumentInContainer(
              environment.businessId,
              this.userInfo.documentContainerId,  //DocContId del usuario loggeado (email)
              rutinaDocModel.documentId,
              this.patternRutinas,
              null,
              rutinaDocModel
            ).subscribe({
              next: (data) => {
                // debugger;
                console.log('rutinasPeriodoActivo', this.rutinasPeriodoActivo)
                console.log(data);
                this.submitFormConstructorRutina = false;
                console.info('Rutina ELIMINADA con éxito');
              },
              error: (error) => {
                console.error(error);
              },
            });
            
          },
          error: (error) => {
            console.log(error);
          }
        })
      }
    })
  }
  deleteRutinaEnProgramaFn(rutinaDocModel, index) {
    // console.log('deleteRutinaEnProgramaFn', rutinaDocModel)
    // console.log('index', index)
    Swal.fire({
      title: 'Eliminar rutina',
      html: '¿Seguro que desea eliminar la rutina: <b>"'+rutinaDocModel.nombre+'"</b>?',
      icon: 'warning',
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Confirmar'
    }).then((result) => {
      if (result.isConfirmed) {
        let periodos = [...this.detallePrograma.periodos];
        periodos[this.filtroPeriodoActivo].rutinas.splice(index, 1);

        // Eliminar rutina de rutinasPorDia si existe
        for(let dia of periodos[this.filtroPeriodoActivo].rutinasPorDia) {
          if(dia.rutina?.documentId == rutinaDocModel.documentId) {
            dia.rutina = {};
          }
        }
        let programaDocument = {
          periodos: periodos
        }
        console.log('--> programaDocument', programaDocument)
        
        // Eliminar rutina en el programa prediseñado
        this.documentService.updateDocumentInContainer(
          environment.businessId,
          this.userInfo.documentContainerId,
          this.detallePrograma.documentId,
          "programa",
          null,
          programaDocument
        ).subscribe({
          next: (data: any) => {
            console.log(data);
            // this.detallePrograma = data;
            this.getDetallePrograma(this.programaId, false);
            this.inicializarDataTableRutinasActivas(null);
            // console.log('detallePrograma', this.detallePrograma)
            console.info('Periodo actualizado con éxito.');

            // Eliminar rutina en la biblioteca
            rutinaDocModel.activo = false;
            this.documentService.updateDocumentInContainer(
              environment.businessId,
              this.userInfo.documentContainerId,  //DocContId del usuario loggeado (email)
              rutinaDocModel.documentId,
              this.patternRutinas,
              null,
              rutinaDocModel
            ).subscribe({
              next: (data) => {
                // debugger;
                console.log('rutinasPeriodoActivo', this.rutinasPeriodoActivo)
                console.log(data);
                this.submitFormConstructorRutina = false;
                console.info('Rutina ELIMINADA con éxito');
              },
              error: (error) => {
                console.error(error);
              },
            });
          },
          error: (error) => {
            console.log(error);
          }
        })
      }
    })
  }

  inicializarFormConstructorRutina()
  {
    if(this.editarRutina)
    {
      this.editarRutina = false;
    }
    const arreglo = this.formConstructorRutina.get('items') as FormArray;
    while (arreglo.length !== 0) {
      arreglo.removeAt(0);
    }
    this.formConstructorRutina.patchValue({
      nombre: '',
      nivel: 'Todos',
      sexo: 'General',
    })
  }
  get formConstructorRutinaControl()
  {
    return this.formConstructorRutina.controls;
  }


  /********* Modal mostrar info *******/
  modalDetalles(objeto)
  {
    this.rutinaSeleccionada = objeto;
    $('#detalleRutinaModal').modal('show');
    console.log(objeto)
  }

  modalDetalleRutina(rutina)
  {
    this.rutinaAEditar = rutina;
    this.formShowRutina.patchValue({
      nombre: this.rutinaAEditar.nombre,
      nivel: this.rutinaAEditar.nivel,
      sexo: this.rutinaAEditar.sexo,
    })

    for(let elemento of this.rutinaAEditar.detalle) this.setFormShowRutina(elemento.tipo, elemento.objInfo, elemento);

    $('#modal-detalle-rutina').modal({backdrop: 'static', keyboard: false})
    $('#modal-detalle-rutina').modal('show');
    console.log(rutina)
  }

  cerrarModalDetalleRutina()
  {
    $('#modal-detalle-rutina').modal('hide');
        if(this.rutinaAEditar)
    {
      this.rutinaAEditar = false;
    }
    const arreglo = this.formShowRutina.get('items') as FormArray;
    while (arreglo.length !== 0) {
      arreglo.removeAt(0);
    }
    this.formShowRutina.patchValue({
      nombre: '',
      nivel: 'Todos',
      sexo: 'General',
    })
    //this.inicializarformShowRutina();
  }

  
  setFormShowRutina(
    tipo: 'titulo' | 'comentario' | 'ejercicio' | 'clase', 
    ejercicioOrClase, 
    elemento //se manda el elemento si se está editan una rutina
  ) {
    const arreglo = this.formShowRutina.get('items') as FormArray;
    let nombre = null;
    if(tipo == 'ejercicio' || tipo == 'clase')
    {
      if(tipo == 'ejercicio') nombre = ejercicioOrClase.nombre1
      if(tipo == 'clase') nombre = ejercicioOrClase.nombre
      const index = arreglo.controls.findIndex(control => 
        control.value.documentId === ejercicioOrClase.documentId &&
        control.value.nombre === nombre
      );
    }

    const grupo = this.fb.group({
      circuitoId:     elemento?.circuitoId ? elemento?.circuitoId : null,
      setsCircuito:   elemento?.setsCircuito ? elemento.setsCircuito : 1,
      startCircuito:  elemento?.startCircuito ? elemento.startCircuito : false,
      tipo:           tipo,
      documentId:     ejercicioOrClase ? ejercicioOrClase.documentId : null,
      nombre:         nombre,
      texto:          elemento?.texto ? elemento.texto : '',
      isSelected:     [false, [Validators.required]],
      objInfo:        ejercicioOrClase ? ejercicioOrClase : null, // se guarda todo el objeto
    })

    arreglo.push(grupo);
    // console.log(this.formConstructorRutina.value)
  }

  
}
